import { get, post } from "@/utils/request"; // 导入模块


//获取全国大区
export const GetRegionComboBox = (params) =>
    get("/GetRegionComboBox", params);
//获取全国大区下的公司
export const GetCompaniesData = (params) =>
    get("/GetCompaniesData", params);

//获取地图下钻
export const GetCompanyPerformanceByProvince = (params) =>
    get("/GetCompanyPerformanceByProvince", params);

//首页-客户数据
export const GetCustomerData = (params) =>
    get("/GetCustomerData", params);

//首页-弹框客户数据
export const GetCustomerDataByDateRange = (params) =>
    get("/GetCustomerDataByDateRange ", params);


//首页-人选推荐
export const GetCandidateData = (params) =>
    get("/GetCandidateData", params);
export const GetRegionalRecommendPersonByDateRange = (params) =>
    get("/GetRegionalRecommendPersonByDateRange", params);
//首页-月回款额
export const GetMonthIncomeAmount = (params) =>
    get("/GetMonthIncomeAmount", params);
export const GetIncomeAmountByDateRange = (params) =>
    get("/GetIncomeAmountByDateRange", params);
//首页-员工数据
export const GetMonthStaffData = (params) =>
    get("/GetMonthStaffData", params);
export const GetStaffDataByDateRange = (params) =>
    get("/GetStaffDataByDateRange", params);
//首页-客户回款等级分布
export const GetIncomeClientGrade = (params) =>
    get("/GetIncomeClientGrade", params);
export const GetRegionalClientGradeByDateRange = (params) =>
    get("/GetRegionalClientGradeByDateRange", params);
//首页-简历数据
export const GetResumeReport = (params) =>
    get("/GetResumeReport", params);
export const GetResumeReportByDateRange = (params) =>
    get("/GetResumeReportByDateRange", params);
// //首页-实时推荐
export const GetRealTimeRecommendData = (params) =>
    get("/GetRealTimeRecommendData", params);
//首页-头部数据
export const GetHomeHeadData = (params) =>
    get("/GetHomeHeadData", params);
//首页-历年大区业绩榜
export const GetCompanyIncomeAmount = (params) =>
    get("/GetCompanyIncomeAmount", params);



//回款分析-回款总额
export const GetRegionalMonthIncomeAmount = (params) =>
    get("/GetRegionalMonthIncomeAmount", params);
//回款分析-回款行业分布
export const GetRegionalClientIndustry = (params) =>
    get("/GetRegionalClientIndustry", params);
//回款分析-回款行业分布
export const GetRegionalClientIndustryByDateRange = (params) =>
    get("/GetRegionalClientIndustryByDateRange ", params);
//回款分析-回款顾问岗位分析
export const GetRegionalCounselorPPerformance = (params) =>
    get("/GetRegionalCounselorPPerformance", params);
//回款分析-客户回款分布
export const GetRegionalClientIncomeAmountGrade = (params) =>
    get("/GetRegionalClientIncomeAmountGrade", params);
export const GetRegionalClientIncomeAmountGradeByDateRange = (params) =>
    get("/GetRegionalClientIncomeAmountGradeByDateRange", params);
//回款分析-工作年限分布
export const GetRegionalCounselorWorkyear = (params) =>
    get("/GetRegionalCounselorWorkyear", params);
//回款分析-工作学历分布
export const GetRegionalCounselorEducation = (params) =>
    get("/GetRegionalCounselorEducation", params);
//回款分析-工作性别分布
export const GetRegionalCounselorGender = (params) =>
    get("/GetRegionalCounselorGender", params);
//回款分析-顾问婚育分布
export const GetRegionalCounselorMarital = (params) =>
    get("/GetRegionalCounselorMarital", params);
//回款分析-客户回款周期
export const GetRegionalClientGradeIncomeCycle = (params) =>
    get("/GetRegionalClientGradeIncomeCycle", params);
export const GetRegionalClientGradeIncomeCycleByDateRange = (params) =>
    get("/GetRegionalClientGradeIncomeCycleByDateRange", params);
//回款分析-客户地域分布
export const GetRegionalIncomeAmountLocation = (params) =>
    get("/GetRegionalIncomeAmountLocation", params);
export const GetIncomeAmount = (params) =>
    get("/GetIncomeAmount", params);



//业绩分析-业绩概况
export const GetRegionalPerfomanceInfo = (params) =>
    get("/GetRegionalPerfomanceInfo", params);
//业绩分析-业绩分布
export const GetRegionalMonthPerfomanceInfo = (params) =>
    get("/GetRegionalMonthPerfomanceInfo", params);
//业绩分析-人选推荐
export const GetRegionalMonthRecommend = (params) =>
    get("/GetRegionalMonthRecommend", params);

export const GetRegionalMonthRecommendByDateRange = (params) =>
    get("/GetRegionalMonthRecommendByDateRange", params);

export const GetRegionalCounselorEducationByDateRange = (params) =>
    get("/GetRegionalCounselorEducationByDateRange", params);

export const GetRegionalCounselorAgeByDateRange = (params) =>
    get("/GetRegionalCounselorAgeByDateRange", params);

    export const GetRegionalCounselorWorkyearByDateRange = (params) =>
    get("/GetRegionalCounselorWorkyearByDateRange", params);

    export const GetRegionalCounselorGenderByDateRange = (params) =>
    get("/GetRegionalCounselorGenderByDateRange", params);



    export const GetRegionalCounselorLevel = (params) =>
    get("/GetRegionalCounselorLevel", params);
    export const GetRegionalCounselorLevelByDateRange = (params) =>
    get("/GetRegionalCounselorLevelByDateRange", params);
//业务顾问职级分布
export const GetRegionalCounselorPPerformanceByDateRange = (params) =>
    get("/GetRegionalCounselorPPerformanceByDateRange", params);
//业绩分析-人选推荐漏斗
export const GetRegionalRecommendPerson = (params) =>
    get("/GetRegionalRecommendPerson", params);
//业绩分析-业务顾问年龄分布
export const GetRegionalCounselorAge = (params) =>
    get("/GetRegionalCounselorAge", params);
//业绩分析-获取分区域业务顾问户籍信息
export const GetRegionalBusinessConsultantLocation = (params) =>
    get("/GetRegionalBusinessConsultantLocation", params);


//经营分析-员工业绩偏离
export const GetStaffPerformance = (params) =>
    get("/GetStaffPerformance", params);
//经营分析-业绩等级分布
export const GetRegionalPerformanceGrade = (params) =>
    get("/GetRegionalPerformanceGrade", params);
export const GetRegionalPerformanceGradeByDateRange = (params) =>
    get("/GetRegionalPerformanceGradeByDateRange", params);
//经营分析-回款客户等级分布
export const GetRegionalClientGrade = (params) =>
    get("/GetRegionalClientGrade", params);
//经营分析-客户客单价分布
export const GetRegionalClientUnitPrice = (params) =>
    get("/GetRegionalClientUnitPrice", params);
export const GetRegionalClientUnitPriceByDateRange = (params) =>
    get("/GetRegionalClientUnitPriceByDateRange", params);
//经营分析-员工职级分布
export const GetRegionalCounselorPosition = (params) =>
    get("/GetRegionalCounselorPosition", params);
export const GetRegionalCounselorPositionByDateRange = (params) =>
    get("/GetRegionalCounselorPositionByDateRange", params);
//经营分析-员工学历分布
export const GetRegionalStaffEducation = (params) =>
    get("/GetRegionalStaffEducation", params);
export const GetRegionalStaffEducationByDateRange = (params) =>
    get("/GetRegionalStaffEducationByDateRange", params);
//经营分析-离职周期分布
export const GetRegionalStaffLeaveCycle = (params) =>
    get("/GetRegionalStaffLeaveCycle", params);
export const GetRegionalStaffLeaveCycleByDateRange = (params) =>
    get("/GetRegionalStaffLeaveCycleByDateRange", params);
//经营分析-全国招聘数据
export const GetStaffCount = (params) =>
    get("/GetStaffCount", params);

export const GetManageDate = (params) =>
    get("/GetManageHeadData", params);


//业务数据分析GetRegionalPerformanceCpyByDateRange 
//业绩同比
export const GetRegionalPerformanceCpyByDateRange = (params) =>
    get("/GetRegionalPerformanceCpyByDateRange ", params);
//各区域客单价
export const GetRegionalRecommendPersonListByDateRange = (params) =>
    get("/GetRegionalRecommendPersonListByDateRange ", params);

//转化率
export const GetRegionalRecommendPersonPerCustomerByDateRange = (params) =>
    get("/GetRegionalRecommendPersonPerCustomerByDateRange  ", params);
//营收支出对比
export const GetRegionalIncomeRatioByDateRange = (params) =>
    get("/GetRegionalIncomeRatioByDateRange  ", params);
//业绩完成率
export const GetRegionalMonthPerfomanceInfoByDateRange = (params) =>
    get("/GetRegionalMonthPerfomanceInfoByDateRange  ", params);
//各区域过程对比
export const GetRegionalRecommendPersonListSortOAByDateRange = (params) =>
    get("/GetRegionalRecommendPersonListSortOAByDateRange  ", params);
//各地区客户总数
export const GetRegionalNewClientByDateRange = (params) =>
    get("/GetRegionalNewClientByDateRange  ", params);
//各地区客户等级
export const GetRegionalClientLevelByDateRange = (params) =>
    get("/GetRegionalClientLevelByDateRange  ", params);


//人员数据分析
//各地区人员同比增长
export const GetRegionalStaffYoyRateByDateRange = (params) =>
    get("/GetRegionalStaffYoyRateByDateRange  ", params);
//各区域净值
export const GetRegionalStaffAddVallueByDateRange = (params) =>
    get("/GetRegionalStaffAddVallueByDateRange  ", params);
//人效
export const GetRegionalStaffPerformanceByDateRange = (params) =>
    get("/GetRegionalStaffPerformanceByDateRange  ", params);
//季度招聘留存率
export const GetRegionalRecruitmentKeepRate = (params) =>
    get("/GetRegionalRecruitmentKeepRate  ", params);
//各公司离职替换率
export const GetRegionalClosePersentByDateRange = (params) =>
    get("/GetRegionalClosePersentByDateRange  ", params);
//各区域招聘完成率
export const GetRegionalTargetPersentByDateRange = (params) =>
    get("/GetRegionalTargetPersentByDateRange  ", params);
//各地区员工占比
export const GetRegionalStaffLevelByDateRange = (params) =>
    get("/GetRegionalStaffLevelByDateRange  ", params);









// WEBPACK FOOTER //
// ./src/api/api.js